import { BaseBus } from "./BaseBus";
import { DateFunctions } from "../static/date-functions";
import { CommonFunctions } from "../static/common-functions";
import { PersonNotificationParam } from "./PersonNotificationParam";
import { CommonValues } from "../static/CommonValues";

export class AssetNotesBus extends BaseBus {
    assetNoteId: string;
    assetId: string;
    personId: string;
    note: string;
    insertUserId: any;
    insertDt: Date;
    updateUserId: any;
    updateDt: Date;
    person: string;
    constructor(busObj: AssetNotesBus = null) {
        super(busObj);
        if (busObj) {
            this.insertDt = DateFunctions.getDate(busObj.insertDt);
            this.updateDt = DateFunctions.getDate(busObj.updateDt);
            this.person = busObj.person || '';
        }
        else {

        }
    }
    setId(id: any) {
        this.assetNoteId = id;
    }
    setParentId(id: any) {
        this.assetId = id;
    }
    CID(): any {
        return this.assetNoteId;
    }
    setNew(userId: any, date: Date, companyId: any = null, personId: any = null, parentId: any = null, other: any = null)
    {
        this.personId = personId;
    }
    //public setFromForm(busObj: any) {
    //    this.assetNoteId = busObj.assetNoteId;
    //    this.assetId = busObj.assetId;
    //    this.personId = busObj.personId;
    //    this.note = busObj.note;
    //    this.insertDt = busObj.insertDt;
    //    this.insertUserId = busObj.insertUserId;
    //    this.updateDt = busObj.updateDt;
    //    this.updateUserId = busObj.updateUserId;

    //    this.displayDt = DateFunctions.formatDate_short(busObj.updateDt);

    //}
    setCommon(userId: any, date: Date, companyId: any = null, personId: any = null) {
        if (!CommonFunctions.hasValue(this.insertDt)) {
            this.insertDt = date;
            this.insertUserId = userId;
        }
        this.updateDt = date;
        this.updateUserId = userId;
    }
    setBeforeSave() {
        this.insertDt = DateFunctions.getDateTimeWithUTCOffset(this.insertDt);
        this.updateDt = DateFunctions.getDateTimeWithUTCOffset(this.updateDt);
    }
    initialize(data: AssetNotesBus) {
        super.initialize(data);
        try {
            this.insertDt = CommonFunctions.getDate(data.insertDt);
            this.updateDt = CommonFunctions.getDate(data.updateDt);
        }
        catch {

        }

    }
}

export class AssetsTrackingBus extends BaseBus {
    assetId: string;
    companyId: string;
    assetNumber: string;
    name: string;
    description: string;
    serial: string;
    model: string;
    manufacturerId: string;
    dispatchId: string;
    inventoryLocationId: string;
    insertDt: Date;
    insertUserId: any;
    updateDt: Date;
    updateUserId: any;
    cost: number;
    assetStatusId: string;
    rfidtag: string;
    co: number;
    assetTypeId: any;
    datePurchased: Date;
    nextServiceDate: Date;
    removeFromServiceDate: Date;
    dateRemovedFromService: Date;
    sendNotificationsTo: string;
    assetNotes: AssetNotesBus[] = [];
    dispatchNumber: string;
    attachmentDetailFullName: string;
    notifyParam: PersonNotificationParam;

    constructor(busObj: AssetsTrackingBus = null) {
        super(busObj);
        if (busObj) {
            if (this.isAdded) {
                this.assetId = '00000000-0000-0000-0000-000000000000';
            }
            this.insertDt = DateFunctions.getDate(busObj.insertDt);
            this.updateDt = DateFunctions.getDate(busObj.updateDt);
            this.datePurchased = DateFunctions.getDate(busObj.datePurchased);
            this.nextServiceDate = DateFunctions.getDate(busObj.nextServiceDate);
            this.removeFromServiceDate = DateFunctions.getDate(busObj.removeFromServiceDate);
            this.dateRemovedFromService = DateFunctions.getDate(busObj.dateRemovedFromService);
            this.assetNotes = [];
            let self = this;
            busObj.assetNotes.forEach(function (n, i) {
                self.assetNotes.push(new AssetNotesBus(n));
            });

        }
    }
    CID(): any {
        return this.assetId;
    }
    setNew(userId: any, date: Date, companyId: any = null, personId: any = null, parentId: any = null, other: any = null)
    {
    }
    setBeforeSave() {

        this.datePurchased = DateFunctions.getDateWithUTCOffset(this.datePurchased);
        this.nextServiceDate = DateFunctions.getDateWithUTCOffset(this.nextServiceDate);
        this.removeFromServiceDate = DateFunctions.getDateWithUTCOffset(this.removeFromServiceDate);
        this.dateRemovedFromService = DateFunctions.getDateWithUTCOffset(this.dateRemovedFromService);
    }
    public setFromForm(busObj: any) {
        this.assetId = busObj.assetId;
        this.companyId = busObj.companyId;
        this.assetNumber = busObj.assetNumber;
        this.name = busObj.name;
        this.description = busObj.description;
        this.serial = busObj.serial;
        this.model = busObj.model;
        this.manufacturerId = busObj.manufacturerId;
        this.dispatchId = busObj.dispatchId;
        this.inventoryLocationId = busObj.inventoryLocationId;
        this.insertDt = busObj.insertDt;
        this.insertUserId = busObj.insertUserId;
        this.updateDt = busObj.updateDt;
        this.updateUserId = busObj.updateUserId;
        this.cost = busObj.cost;
        this.assetStatusId = busObj.assetStatusId;
        this.rfidtag = busObj.rfidtag;
        this.co = busObj.co;
        this.dispatchNumber = busObj.dispatchNumber;
        this.attachmentDetailFullName = busObj.attachmentDetailFullName;
        this.assetTypeId = busObj.assetTypeId;
        this.datePurchased = busObj.datePurchased;
        this.nextServiceDate = busObj.nextServiceDate;
        this.removeFromServiceDate = busObj.removeFromServiceDate;
        this.dateRemovedFromService = busObj.dateRemovedFromService;
//        this.assetNotes = busObj.assetNotes || [];
    }
}